import { render, staticRenderFns } from "./StreamlineEmbedWidget.vue?vue&type=template&id=4fd87c40&scoped=true"
import script from "./StreamlineEmbedWidget.vue?vue&type=script&lang=js"
export * from "./StreamlineEmbedWidget.vue?vue&type=script&lang=js"
import style0 from "./StreamlineEmbedWidget.vue?vue&type=style&index=0&id=4fd87c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd87c40",
  null
  
)

export default component.exports